/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type routes_FrameViewer_QueryVariables = {
    runName: string;
    sensorName: string;
    indexInSensorStream: number;
    timestamp?: string | null;
};
export type routes_FrameViewer_QueryResponse = {
    readonly viewer: {
        readonly id: string;
        readonly isAnonymous: boolean | null;
        readonly isApprovedForAccess: boolean | null;
        readonly " $fragmentRefs": FragmentRefs<"FrameViewer_viewer">;
    } | null;
};
export type routes_FrameViewer_Query = {
    readonly response: routes_FrameViewer_QueryResponse;
    readonly variables: routes_FrameViewer_QueryVariables;
};



/*
query routes_FrameViewer_Query(
  $runName: String!
  $sensorName: String!
  $indexInSensorStream: Int!
  $timestamp: String
) {
  viewer {
    id
    isAnonymous
    isApprovedForAccess
    ...FrameViewer_viewer
  }
}

fragment CanvasRenderer_frame on Frame {
  id
  cameraModel {
    id
    height
    width
    fx
    fy
    cx
    cy
  }
  knownObjectPoses {
    id
    distance
    position {
      x
      y
      z
    }
    orientation {
      w
      x
      y
      z
    }
    targetState
    knownObject
  }
  labeledItems {
    id
    number
    objectType
    thwartedPallets {
      id
      number
    }
    author {
      username
      id
    }
    shape {
      id
      faces {
        id
        parentShape {
          id
          faces {
            id
          }
        }
        side
        corners {
          id
          x
          y
          visibility
        }
      }
    }
  }
  labeledBoxes {
    id
    number
    objectType
    author {
      username
      id
    }
    pallet {
      id
      number
    }
    shape {
      id
      faces {
        id
        parentShape {
          id
          faces {
            id
          }
        }
        side
        corners {
          id
          x
          y
          visibility
        }
      }
    }
  }
  labeledPallets {
    id
    number
    objectType
    surfaceType
    obstacles {
      number
      id
    }
    author {
      username
      id
    }
    sidePockets {
      id
      left {
        id
        corners {
          id
          x
          y
          visibility
        }
      }
      right {
        id
        corners {
          id
          x
          y
          visibility
        }
      }
    }
    frontPockets {
      id
      left {
        id
        corners {
          id
          x
          y
          visibility
        }
      }
      right {
        id
        corners {
          id
          x
          y
          visibility
        }
      }
    }
    shape {
      id
      faces {
        id
        parentShape {
          id
          faces {
            id
          }
        }
        side
        corners {
          id
          x
          y
          visibility
        }
      }
    }
    load {
      id
      faces {
        id
        parentShape {
          id
          faces {
            id
          }
        }
        side
        corners {
          id
          x
          y
          visibility
        }
      }
    }
  }
  detectedPallets {
    id
    objectType
    shape {
      id
      faces {
        id
        parentShape {
          id
          faces {
            id
          }
        }
        side
        corners {
          id
          x
          y
          visibility
        }
      }
    }
  }
  indexInSensorStream
  imageMetadata {
    id
    height
    width
  }
}

fragment CreateIssueDialog_frame on Frame {
  id
  sensorStream {
    id
  }
  labelers {
    id
    username
    shortName
  }
  labeledBoxes {
    id
    number
  }
  labeledPallets {
    id
    number
  }
  qaInspections {
    category
  }
}

fragment FrameQADialog_frame on Frame {
  id
  labelers {
    id
    username
  }
  qaInspections {
    inspector {
      id
      username
    }
    labeler {
      id
      username
    }
    category
    state
  }
}

fragment FrameViewer_viewer on Viewer {
  id
  isAnonymous
  isSupervisor
  isVetted
  isQualityController
  userId
  username
  frame: frameBySensor(runName: $runName, sensorName: $sensorName, indexInSensorStream: $indexInSensorStream, timestamp: $timestamp) {
    ...CanvasRenderer_frame
    ...SideBar_frame
    ...IssuesBar_frame
    ...FrameQADialog_frame
    id
    indexInSensorStream
    timestamp
    cameraModel {
      height
      width
      fx
      fy
      cx
      cy
      id
    }
    labeledBoxes {
      id
      number
      frame {
        id
      }
      author {
        id
        username
      }
      pallet {
        number
        id
      }
      shape {
        id
        faces {
          id
          side
          corners {
            id
            x
            y
            visibility
          }
        }
      }
    }
    labeledItems {
      id
      number
      frame {
        id
      }
      author {
        id
        username
      }
      thwartedPallets {
        number
        id
      }
      shape {
        id
        faces {
          id
          side
          corners {
            id
            x
            y
            visibility
          }
        }
      }
    }
    labeledPallets {
      id
      number
      surfaceType
      frame {
        id
      }
      author {
        id
        username
      }
      sidePockets {
        left {
          corners {
            id
            x
            y
            visibility
          }
          id
        }
        right {
          corners {
            id
            x
            y
            visibility
          }
          id
        }
        id
      }
      frontPockets {
        left {
          corners {
            id
            x
            y
            visibility
          }
          id
        }
        right {
          corners {
            id
            x
            y
            visibility
          }
          id
        }
        id
      }
      shape {
        id
        faces {
          id
          side
          corners {
            id
            x
            y
            visibility
          }
        }
      }
      load {
        id
        faces {
          id
          side
          corners {
            id
            x
            y
            visibility
          }
        }
      }
    }
    knownObjectPoses {
      id
      targetState
      knownObject
      orientation {
        w
        x
        y
        z
      }
      position {
        x
        y
        z
      }
      distance
    }
    imageMetadata {
      height
      width
      signedUrl
      id
    }
  }
}

fragment IssuesBar_frame on Frame {
  ...CreateIssueDialog_frame
  id
  indexInSensorStream
  issues {
    id
    ...LabelingIssueSideBarListItem_issue
  }
  sensorStream {
    issues {
      id
      ...LabelingIssueSideBarListItem_issue
    }
    id
  }
}

fragment ItemDetails_item on LabeledItem {
  id
  shape {
    faces {
      id
      side
      corners {
        id
        x
        y
        visibility
      }
    }
    id
  }
  number
  objectType
  thwartedPallets {
    id
    number
  }
  frame {
    labeledPallets {
      id
      number
    }
    id
  }
}

fragment ItemSideBar_frame on Frame {
  id
  labeledItems {
    ...ItemDetails_item
    id
    number
    author {
      id
      username
    }
  }
}

fragment LabelFaceListItem_face on CuboidFace {
  id
  side
  corners {
    id
    x
    y
    visibility
  }
}

fragment LabelFaceList_label on FrameLabel {
  ... on LabeledBox {
    id
  }
  ... on LabeledPallet {
    id
    load {
      id
      faces {
        corners {
          id
        }
        id
        side
        ...LabelFaceListItem_face
      }
    }
    frontPockets {
      id
      left {
        id
      }
      right {
        id
      }
    }
    sidePockets {
      id
      left {
        id
      }
      right {
        id
      }
    }
  }
  number
  objectType
  shape {
    faces {
      corners {
        id
      }
      side
      ...LabelFaceListItem_face
      id
    }
    id
  }
}

fragment LabelingIssueSideBarListItem_issue on LabelingIssue {
  id
  description
  category
  status
  reporter {
    username
    id
  }
  pallets {
    number
    id
  }
  boxes {
    number
    id
  }
  sensorStream {
    sensorName
    run {
      runName
      source
      id
    }
    id
  }
  frame {
    id
    indexInSensorStream
  }
}

fragment PalletDetails_pallet on LabeledPallet {
  id
  ...LabelFaceList_label
  number
  objectType
  surfaceType
  boxes {
    id
    number
  }
  frame {
    labeledBoxes {
      id
      number
      pallet {
        id
      }
    }
    id
  }
}

fragment PalletSideBar_frame on Frame {
  id
  indexInSensorStream
  sensorStream {
    labelers {
      id
      username
      shortName
    }
    id
  }
  labeledPallets {
    ...PalletDetails_pallet
    id
    number
    author {
      id
      username
    }
  }
}

fragment SideBar_frame on Frame {
  knownObjectPoses {
    id
    knownObject
    targetState
    orientation {
      w
      x
      y
      z
    }
    position {
      x
      y
      z
    }
  }
  ...PalletSideBar_frame
  ...ItemSideBar_frame
  id
  indexInSensorStream
  sensorStream {
    labelers {
      id
      username
      shortName
    }
    id
  }
  labeledPallets {
    ...PalletDetails_pallet
    id
    number
    author {
      id
      username
    }
  }
  labeledItems {
    ...ItemDetails_item
    id
    number
    author {
      id
      username
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "runName",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sensorName",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "indexInSensorStream",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "timestamp",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isAnonymous",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isApprovedForAccess",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "height",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "width",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "x",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "y",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "z",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "number",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "objectType",
  "args": null,
  "storageKey": null
},
v12 = [
  (v1/*: any*/),
  (v10/*: any*/)
],
v13 = [
  (v4/*: any*/),
  (v1/*: any*/)
],
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "author",
  "storageKey": null,
  "args": null,
  "concreteType": "LabelerUser",
  "plural": false,
  "selections": (v13/*: any*/)
},
v15 = [
  (v1/*: any*/)
],
v16 = [
  (v1/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "visibility",
    "args": null,
    "storageKey": null
  }
],
v17 = [
  (v1/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "faces",
    "storageKey": null,
    "args": null,
    "concreteType": "CuboidFace",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "parentShape",
        "storageKey": null,
        "args": null,
        "concreteType": "Cuboid",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "faces",
            "storageKey": null,
            "args": null,
            "concreteType": "CuboidFace",
            "plural": true,
            "selections": (v15/*: any*/)
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "side",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "corners",
        "storageKey": null,
        "args": null,
        "concreteType": "CuboidCorner",
        "plural": true,
        "selections": (v16/*: any*/)
      }
    ]
  }
],
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "shape",
  "storageKey": null,
  "args": null,
  "concreteType": "Cuboid",
  "plural": false,
  "selections": (v17/*: any*/)
},
v19 = [
  (v10/*: any*/),
  (v1/*: any*/)
],
v20 = [
  (v1/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "corners",
    "storageKey": null,
    "args": null,
    "concreteType": "QuadCorner",
    "plural": true,
    "selections": (v16/*: any*/)
  }
],
v21 = [
  (v1/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "left",
    "storageKey": null,
    "args": null,
    "concreteType": "Quad",
    "plural": false,
    "selections": (v20/*: any*/)
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "right",
    "storageKey": null,
    "args": null,
    "concreteType": "Quad",
    "plural": false,
    "selections": (v20/*: any*/)
  }
],
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "indexInSensorStream",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "labelers",
  "storageKey": null,
  "args": null,
  "concreteType": "LabelerUser",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shortName",
      "args": null,
      "storageKey": null
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "category",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "issues",
  "storageKey": null,
  "args": null,
  "concreteType": "LabelingIssue",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    (v24/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "reporter",
      "storageKey": null,
      "args": null,
      "concreteType": "LabelerUser",
      "plural": false,
      "selections": (v13/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pallets",
      "storageKey": null,
      "args": null,
      "concreteType": "LabeledPallet",
      "plural": true,
      "selections": (v19/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "boxes",
      "storageKey": null,
      "args": null,
      "concreteType": "LabeledBox",
      "plural": true,
      "selections": (v19/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sensorStream",
      "storageKey": null,
      "args": null,
      "concreteType": "SensorStream",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "sensorName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "run",
          "storageKey": null,
          "args": null,
          "concreteType": "Run",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "runName",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "source",
              "args": null,
              "storageKey": null
            },
            (v1/*: any*/)
          ]
        },
        (v1/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "frame",
      "storageKey": null,
      "args": null,
      "concreteType": "Frame",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v22/*: any*/)
      ]
    }
  ]
},
v26 = [
  (v1/*: any*/),
  (v4/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "routes_FrameViewer_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "FrameViewer_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "routes_FrameViewer_Query",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isSupervisor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVetted",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isQualityController",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "userId",
            "args": null,
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": "frame",
            "name": "frameBySensor",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "indexInSensorStream",
                "variableName": "indexInSensorStream"
              },
              {
                "kind": "Variable",
                "name": "runName",
                "variableName": "runName"
              },
              {
                "kind": "Variable",
                "name": "sensorName",
                "variableName": "sensorName"
              },
              {
                "kind": "Variable",
                "name": "timestamp",
                "variableName": "timestamp"
              }
            ],
            "concreteType": "Frame",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "cameraModel",
                "storageKey": null,
                "args": null,
                "concreteType": "CameraModel",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fx",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fy",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cx",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cy",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "knownObjectPoses",
                "storageKey": null,
                "args": null,
                "concreteType": "KnownObjectPose",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "distance",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "position",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Vector3",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "orientation",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Quaternion",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "w",
                        "args": null,
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "targetState",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "knownObject",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "labeledItems",
                "storageKey": null,
                "args": null,
                "concreteType": "LabeledItem",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "thwartedPallets",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LabeledPallet",
                    "plural": true,
                    "selections": (v12/*: any*/)
                  },
                  (v14/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "frame",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Frame",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "labeledPallets",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LabeledPallet",
                        "plural": true,
                        "selections": (v12/*: any*/)
                      },
                      (v1/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "labeledBoxes",
                "storageKey": null,
                "args": null,
                "concreteType": "LabeledBox",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v14/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pallet",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LabeledPallet",
                    "plural": false,
                    "selections": (v12/*: any*/)
                  },
                  (v18/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "frame",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Frame",
                    "plural": false,
                    "selections": (v15/*: any*/)
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "labeledPallets",
                "storageKey": null,
                "args": null,
                "concreteType": "LabeledPallet",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "surfaceType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "obstacles",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LabeledItem",
                    "plural": true,
                    "selections": (v19/*: any*/)
                  },
                  (v14/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "sidePockets",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PalletPocket",
                    "plural": false,
                    "selections": (v21/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "frontPockets",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PalletPocket",
                    "plural": false,
                    "selections": (v21/*: any*/)
                  },
                  (v18/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "load",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Cuboid",
                    "plural": false,
                    "selections": (v17/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "boxes",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LabeledBox",
                    "plural": true,
                    "selections": (v12/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "frame",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Frame",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "labeledBoxes",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LabeledBox",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/),
                          (v10/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pallet",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LabeledPallet",
                            "plural": false,
                            "selections": (v15/*: any*/)
                          }
                        ]
                      },
                      (v1/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "detectedPallets",
                "storageKey": null,
                "args": null,
                "concreteType": "DetectedPallet",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v11/*: any*/),
                  (v18/*: any*/)
                ]
              },
              (v22/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "imageMetadata",
                "storageKey": null,
                "args": null,
                "concreteType": "ImageMetadata",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "signedUrl",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "sensorStream",
                "storageKey": null,
                "args": null,
                "concreteType": "SensorStream",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  (v1/*: any*/),
                  (v25/*: any*/)
                ]
              },
              (v23/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "qaInspections",
                "storageKey": null,
                "args": null,
                "concreteType": "QAInspection",
                "plural": true,
                "selections": [
                  (v24/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "inspector",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LabelerUser",
                    "plural": false,
                    "selections": (v26/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "labeler",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LabelerUser",
                    "plural": false,
                    "selections": (v26/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "state",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              (v25/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "timestamp",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "routes_FrameViewer_Query",
    "id": null,
    "text": "query routes_FrameViewer_Query(\n  $runName: String!\n  $sensorName: String!\n  $indexInSensorStream: Int!\n  $timestamp: String\n) {\n  viewer {\n    id\n    isAnonymous\n    isApprovedForAccess\n    ...FrameViewer_viewer\n  }\n}\n\nfragment CanvasRenderer_frame on Frame {\n  id\n  cameraModel {\n    id\n    height\n    width\n    fx\n    fy\n    cx\n    cy\n  }\n  knownObjectPoses {\n    id\n    distance\n    position {\n      x\n      y\n      z\n    }\n    orientation {\n      w\n      x\n      y\n      z\n    }\n    targetState\n    knownObject\n  }\n  labeledItems {\n    id\n    number\n    objectType\n    thwartedPallets {\n      id\n      number\n    }\n    author {\n      username\n      id\n    }\n    shape {\n      id\n      faces {\n        id\n        parentShape {\n          id\n          faces {\n            id\n          }\n        }\n        side\n        corners {\n          id\n          x\n          y\n          visibility\n        }\n      }\n    }\n  }\n  labeledBoxes {\n    id\n    number\n    objectType\n    author {\n      username\n      id\n    }\n    pallet {\n      id\n      number\n    }\n    shape {\n      id\n      faces {\n        id\n        parentShape {\n          id\n          faces {\n            id\n          }\n        }\n        side\n        corners {\n          id\n          x\n          y\n          visibility\n        }\n      }\n    }\n  }\n  labeledPallets {\n    id\n    number\n    objectType\n    surfaceType\n    obstacles {\n      number\n      id\n    }\n    author {\n      username\n      id\n    }\n    sidePockets {\n      id\n      left {\n        id\n        corners {\n          id\n          x\n          y\n          visibility\n        }\n      }\n      right {\n        id\n        corners {\n          id\n          x\n          y\n          visibility\n        }\n      }\n    }\n    frontPockets {\n      id\n      left {\n        id\n        corners {\n          id\n          x\n          y\n          visibility\n        }\n      }\n      right {\n        id\n        corners {\n          id\n          x\n          y\n          visibility\n        }\n      }\n    }\n    shape {\n      id\n      faces {\n        id\n        parentShape {\n          id\n          faces {\n            id\n          }\n        }\n        side\n        corners {\n          id\n          x\n          y\n          visibility\n        }\n      }\n    }\n    load {\n      id\n      faces {\n        id\n        parentShape {\n          id\n          faces {\n            id\n          }\n        }\n        side\n        corners {\n          id\n          x\n          y\n          visibility\n        }\n      }\n    }\n  }\n  detectedPallets {\n    id\n    objectType\n    shape {\n      id\n      faces {\n        id\n        parentShape {\n          id\n          faces {\n            id\n          }\n        }\n        side\n        corners {\n          id\n          x\n          y\n          visibility\n        }\n      }\n    }\n  }\n  indexInSensorStream\n  imageMetadata {\n    id\n    height\n    width\n  }\n}\n\nfragment CreateIssueDialog_frame on Frame {\n  id\n  sensorStream {\n    id\n  }\n  labelers {\n    id\n    username\n    shortName\n  }\n  labeledBoxes {\n    id\n    number\n  }\n  labeledPallets {\n    id\n    number\n  }\n  qaInspections {\n    category\n  }\n}\n\nfragment FrameQADialog_frame on Frame {\n  id\n  labelers {\n    id\n    username\n  }\n  qaInspections {\n    inspector {\n      id\n      username\n    }\n    labeler {\n      id\n      username\n    }\n    category\n    state\n  }\n}\n\nfragment FrameViewer_viewer on Viewer {\n  id\n  isAnonymous\n  isSupervisor\n  isVetted\n  isQualityController\n  userId\n  username\n  frame: frameBySensor(runName: $runName, sensorName: $sensorName, indexInSensorStream: $indexInSensorStream, timestamp: $timestamp) {\n    ...CanvasRenderer_frame\n    ...SideBar_frame\n    ...IssuesBar_frame\n    ...FrameQADialog_frame\n    id\n    indexInSensorStream\n    timestamp\n    cameraModel {\n      height\n      width\n      fx\n      fy\n      cx\n      cy\n      id\n    }\n    labeledBoxes {\n      id\n      number\n      frame {\n        id\n      }\n      author {\n        id\n        username\n      }\n      pallet {\n        number\n        id\n      }\n      shape {\n        id\n        faces {\n          id\n          side\n          corners {\n            id\n            x\n            y\n            visibility\n          }\n        }\n      }\n    }\n    labeledItems {\n      id\n      number\n      frame {\n        id\n      }\n      author {\n        id\n        username\n      }\n      thwartedPallets {\n        number\n        id\n      }\n      shape {\n        id\n        faces {\n          id\n          side\n          corners {\n            id\n            x\n            y\n            visibility\n          }\n        }\n      }\n    }\n    labeledPallets {\n      id\n      number\n      surfaceType\n      frame {\n        id\n      }\n      author {\n        id\n        username\n      }\n      sidePockets {\n        left {\n          corners {\n            id\n            x\n            y\n            visibility\n          }\n          id\n        }\n        right {\n          corners {\n            id\n            x\n            y\n            visibility\n          }\n          id\n        }\n        id\n      }\n      frontPockets {\n        left {\n          corners {\n            id\n            x\n            y\n            visibility\n          }\n          id\n        }\n        right {\n          corners {\n            id\n            x\n            y\n            visibility\n          }\n          id\n        }\n        id\n      }\n      shape {\n        id\n        faces {\n          id\n          side\n          corners {\n            id\n            x\n            y\n            visibility\n          }\n        }\n      }\n      load {\n        id\n        faces {\n          id\n          side\n          corners {\n            id\n            x\n            y\n            visibility\n          }\n        }\n      }\n    }\n    knownObjectPoses {\n      id\n      targetState\n      knownObject\n      orientation {\n        w\n        x\n        y\n        z\n      }\n      position {\n        x\n        y\n        z\n      }\n      distance\n    }\n    imageMetadata {\n      height\n      width\n      signedUrl\n      id\n    }\n  }\n}\n\nfragment IssuesBar_frame on Frame {\n  ...CreateIssueDialog_frame\n  id\n  indexInSensorStream\n  issues {\n    id\n    ...LabelingIssueSideBarListItem_issue\n  }\n  sensorStream {\n    issues {\n      id\n      ...LabelingIssueSideBarListItem_issue\n    }\n    id\n  }\n}\n\nfragment ItemDetails_item on LabeledItem {\n  id\n  shape {\n    faces {\n      id\n      side\n      corners {\n        id\n        x\n        y\n        visibility\n      }\n    }\n    id\n  }\n  number\n  objectType\n  thwartedPallets {\n    id\n    number\n  }\n  frame {\n    labeledPallets {\n      id\n      number\n    }\n    id\n  }\n}\n\nfragment ItemSideBar_frame on Frame {\n  id\n  labeledItems {\n    ...ItemDetails_item\n    id\n    number\n    author {\n      id\n      username\n    }\n  }\n}\n\nfragment LabelFaceListItem_face on CuboidFace {\n  id\n  side\n  corners {\n    id\n    x\n    y\n    visibility\n  }\n}\n\nfragment LabelFaceList_label on FrameLabel {\n  ... on LabeledBox {\n    id\n  }\n  ... on LabeledPallet {\n    id\n    load {\n      id\n      faces {\n        corners {\n          id\n        }\n        id\n        side\n        ...LabelFaceListItem_face\n      }\n    }\n    frontPockets {\n      id\n      left {\n        id\n      }\n      right {\n        id\n      }\n    }\n    sidePockets {\n      id\n      left {\n        id\n      }\n      right {\n        id\n      }\n    }\n  }\n  number\n  objectType\n  shape {\n    faces {\n      corners {\n        id\n      }\n      side\n      ...LabelFaceListItem_face\n      id\n    }\n    id\n  }\n}\n\nfragment LabelingIssueSideBarListItem_issue on LabelingIssue {\n  id\n  description\n  category\n  status\n  reporter {\n    username\n    id\n  }\n  pallets {\n    number\n    id\n  }\n  boxes {\n    number\n    id\n  }\n  sensorStream {\n    sensorName\n    run {\n      runName\n      source\n      id\n    }\n    id\n  }\n  frame {\n    id\n    indexInSensorStream\n  }\n}\n\nfragment PalletDetails_pallet on LabeledPallet {\n  id\n  ...LabelFaceList_label\n  number\n  objectType\n  surfaceType\n  boxes {\n    id\n    number\n  }\n  frame {\n    labeledBoxes {\n      id\n      number\n      pallet {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment PalletSideBar_frame on Frame {\n  id\n  indexInSensorStream\n  sensorStream {\n    labelers {\n      id\n      username\n      shortName\n    }\n    id\n  }\n  labeledPallets {\n    ...PalletDetails_pallet\n    id\n    number\n    author {\n      id\n      username\n    }\n  }\n}\n\nfragment SideBar_frame on Frame {\n  knownObjectPoses {\n    id\n    knownObject\n    targetState\n    orientation {\n      w\n      x\n      y\n      z\n    }\n    position {\n      x\n      y\n      z\n    }\n  }\n  ...PalletSideBar_frame\n  ...ItemSideBar_frame\n  id\n  indexInSensorStream\n  sensorStream {\n    labelers {\n      id\n      username\n      shortName\n    }\n    id\n  }\n  labeledPallets {\n    ...PalletDetails_pallet\n    id\n    number\n    author {\n      id\n      username\n    }\n  }\n  labeledItems {\n    ...ItemDetails_item\n    id\n    number\n    author {\n      id\n      username\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '309167e32c27810fd90b9becc674130b';
export default node;
